import { render } from "./AdressFormMobile.vue?vue&type=template&id=4e152224&scoped=true"
import script from "./AdressFormMobile.vue?vue&type=script&lang=js"
export * from "./AdressFormMobile.vue?vue&type=script&lang=js"

import "./AdressFormMobile.vue?vue&type=style&index=0&id=4e152224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e152224"]])

export default __exports__